var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_clipboard-text",
    "data-name": "vuesax/bold/clipboard-text",
    transform: "translate(-108 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clipboard-text",
    transform: "translate(108 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.983,0H3.15A3.144,3.144,0,0,0,0,3.133V4.7A3.13,3.13,0,0,0,3.133,7.833h7.85A3.13,3.13,0,0,0,14.117,4.7V3.133A3.119,3.119,0,0,0,10.983,0Z",
    transform: "translate(12.933 3.333)",
    fill: "#1a3680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M23.25,1.229a4.83,4.83,0,0,1-4.817,4.817H10.6A4.83,4.83,0,0,1,5.783,1.229,1.244,1.244,0,0,0,3.95.146,7.453,7.453,0,0,0,0,6.729V22.412a7.469,7.469,0,0,0,7.45,7.45H21.583a7.469,7.469,0,0,0,7.45-7.45V6.729A7.453,7.453,0,0,0,25.083.146,1.244,1.244,0,0,0,23.25,1.229Zm-8.1,20.217H7.85a1.25,1.25,0,0,1,0-2.5h7.3a1.25,1.25,0,0,1,0,2.5Zm4.367-6.667H7.85a1.25,1.25,0,0,1,0-2.5H19.517a1.25,1.25,0,0,1,0,2.5Z",
    transform: "translate(5.483 6.804)",
    fill: "#1a3680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H40V40H0Z",
    transform: "translate(40 40) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardIcon);
export default __webpack_public_path__ + "static/media/board_icon.0d852c2d344f8c794873b7e98736e32c.svg";
export { ForwardRef as ReactComponent };